import React from "react";
import { SimpleFormLabel, SimpleFormTextField } from "components/dialogs/SimpleFormDialog";
import { Box, Button, DialogActions, DialogContent, DialogTitle,  Typography, Paper } from "@mui/material";
import ResponsiveDialog from "components/dialogs/ResponsiveDialog";
import { useTranslation } from 'react-i18next';
import { useTheme } from "@mui/material/styles";
import { PDFExportOptions } from 'utils/usePDFExport';

interface WidgetPDFDownloadDialogOptions {
  defaultFilename?: string;
  onDownloadPDF?: (options?: PDFExportOptions) => Promise<void>;
  onClose: () => void;
}

export default function WidgetPDFDownloadDialog(props: WidgetPDFDownloadDialogOptions): JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const [pdfFileName, setPdfFileName] = React.useState<string>(props.defaultFilename ?? i18n.t("widgets.default-pdf-filename"));
  const [isExporting, setIsExporting] = React.useState<boolean>(false);

  const handleExportPDF = async () => {
    if (props.onDownloadPDF) {
      setIsExporting(true);
      await props.onDownloadPDF({ filename: pdfFileName });
      setIsExporting(false);
      props.onClose();
    }
  }

  return (
    <ResponsiveDialog
      maxWidth="sm"
      open={true}
      onClose={props.onClose}
      className="drag-cancel"
    >
      <DialogTitle>
        <Typography variant="h4">
          {i18n.t("widgets.download-pdf-dialog")}
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ backgroundColor: theme.palette.background.default, p: 1 }} >
        <Paper sx={{display:"grid", gridTemplateColumns: "auto", columnGap: 2, p: 2}}>
          <Box>
            <SimpleFormLabel>{i18n.t("widgets.export-filename")}</SimpleFormLabel>
            <SimpleFormTextField value={pdfFileName} onChange={(e) => setPdfFileName(e.target.value)}/>
          </Box>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={props.onClose}
          variant="contained"
          color="secondary">
          {i18n.t("cancel")}
        </Button>
        <Button
          onClick={handleExportPDF}
          loading={isExporting}
          variant="contained"
        >
          {i18n.t("widgets.download")}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
